module.exports = "pegasus/assets/circleline-pinterest.gif";